const basePaper = {
  default: {
    background: 'white',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'coolGrey.10',
    borderRadius: 'paper',
    padding: 6
  },
  raised: {
    background: 'white',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'coolGrey.10',
    borderRadius: 'paper',
    boxShadow: '20',
    padding: 6
  },
  raisedLow: {
    background: 'white',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'coolGrey.10',
    borderRadius: 'paper',
    boxShadow: '10',
    padding: 6
  }
};

const paper = {
  products: {
    chart: basePaper,
    chartblog: basePaper,
    co: basePaper,
    edu: basePaper,
    scale: basePaper,
    spark: basePaper
  }
};

export type PaperVariantsType = 'default' | 'raised'| 'raisedLow';
export const paperVariants = Object.keys(basePaper) as PaperVariantsType[];

export default paper;
